// 钓鱼, the part every page loads (kept small on purpose): what the map needs to draw everyone's lines, and the door
// into 钓鱼 mode. Nothing here shows on the page's own interface (no button in the bar, no key, no toast, no chat
// line): 钓鱼 is opened at a fishing spot (public/pick.js: click the sea at the shore → 「钓鱼」), and its whole UI
// (cast, reel, catch card, 鱼篓/图鉴, 纪录) is public/fishing-mode.js, loaded the first time someone opens it.
// The map draws the rods, bobbers and catches from what this keeps on each otter (deck/entities.js Fishing):
//   p.fish = {phase, bx, by, dir, since, phaseAt} while a line is out, p.fishPop = {i, at, bx, by} for a catch (the
//   fish jumping out over the angler's head: the only sign of someone else's catch).

import { t } from '/i18n.js';

/**
 * @param {object} o
 * @param {(m: object) => void} o.send
 * @param {() => object|null} o.me  @param {() => Map} o.peers
 * @param {object} o.MAP the map (deck/map.js)
 * @param {(text: string, go?: Function, icon?: string) => void} o.toast
 * @returns {{msg(m), open(), close(), busy(), active(), reset()}}
 */
export function initFishing({ send, me, peers, MAP, toast }) {
  let mode = null, loading = null;
  const now = () => performance.now();
  const otter = (id) => (id === me()?.id ? me() : peers().get(id));
  function load() {
    loading ??= import('/fishing-mode.js')
      .then((m) => (mode = m.createFishingMode({ send, me, MAP, toast })))
      .catch((e) => { loading = null; throw e; });
    return loading;
  }

  function msg(m) {
    if (m.t === 'f_line') {
      const p = otter(m.id);
      if (p) {
        if (m.phase === 'none') { if (p.fish) p.fishLast = { bx: p.fish.bx, by: p.fish.by }; p.fish = null; }
        else {
          const t = now();
          if (!p.fish) p.fish = { since: t, phaseAt: t };
          if (p.fish.phase !== m.phase) p.fish.phaseAt = t;
          Object.assign(p.fish, { phase: m.phase, bx: m.bx, by: m.by, dir: m.dir });
          p.dir = m.dir; p.dir8 = m.dir * 2; p.dir16 = m.dir * 4;
        }
      }
    } else if (m.t === 'f_catch') {
      const p = otter(m.id), at = p?.fish || p?.fishLast;
      if (p && at && Number.isInteger(m.i) && m.i >= 0) p.fishPop = { i: m.i, at: now(), bx: at.bx + 0.5, by: at.by + 0.5 };
    }
    mode?.msg(m); // my own line's messages (f_line, f_bite, f_reel, f_step, f_result, f_err, f_book, f_catch)
  }

  return {
    msg,
    /** Open 钓鱼 mode where I stand (pick.js, once I'm at the spot). */
    open() { load().then((md) => md.open()).catch(() => toast(t('fish.err.load'))); },
    close() { mode?.close(); },
    /** A line of mine is out (pick.js 钓鱼 doesn't open it again). */
    busy: () => !!mode?.busy(),
    /** 钓鱼 mode is open. */
    active: () => !!mode?.active(),
    /** A new connection (welcome): no line of mine is out any more. */
    reset() { mode?.reset(); },
  };
}
